import * as React from "react";
import classNames from "classnames";

import "./Header.scss";

export interface HeaderProps {
  headerText: string;
  id?: string;
  classes?: string;
  headerType?: "h1" | "h2" | "h3" | "h4";
}

export const Header = (props: HeaderProps) => {
  const HeaderTypeElement = props.headerType ?? "h1";
  const allClasses = classNames(props.classes ?? props.classes);

  return (
    <>
      {props.headerText.length > 0 && (
        <HeaderTypeElement id={props.id} className={allClasses}>
          {props.headerText}
        </HeaderTypeElement>
      )}
    </>
  );
};
